/*
 * Keeps the cart in the market of the page the shopper is looking at.
 *
 * A browser has one Shopify cart, shared by every market (SG at /, AU at
 * /en-au). Whichever page was last *loaded* sets the cart's market, so opening
 * an SG page in another tab, or going Back from one, leaves an AU page that is
 * still on screen sitting on an SGD cart. AJAX requests from that page then
 * follow the cart, not the URL: even /en-au/products/x?view=... comes back in
 * SGD. Build-a-Gift, which fetches every item it adds, mixed currencies.
 *
 * When the tab is shown again (tab switch, or a Back that restores the page
 * from the bfcache) we compare the cart with the page and, if they differ,
 * move the cart back with the same /localization request the currency
 * switcher posts. No reload, so state built up on the page (a gift box in
 * progress) survives. window.marketGuard.ensure() runs the same check on
 * demand, before a fetch whose response carries prices.
 */
(function () {
  var shop = window.Shopify || {};
  var root = (shop.routes && shop.routes.root) || '/';
  var pageCurrency = shop.currency && shop.currency.active;
  var pageCountry = shop.country;
  if (!pageCurrency || !pageCountry || !window.fetch) return;

  var pending = null;

  // Resolves with the cart as /localization leaves it: we point return_to at
  // cart.js, so the redirect hands back the re-localised cart.
  function relocalise() {
    var body = new FormData();
    body.append('form_type', 'localization');
    body.append('utf8', '✓');
    body.append('_method', 'put');
    body.append('return_to', root + 'cart.js');
    body.append('country_code', pageCountry);
    return fetch(root + 'localization', {
      method: 'POST',
      body: body,
      credentials: 'same-origin'
    }).then(function (res) {
      return res.json();
    });
  }

  // Resolves true once the cart is in the page's currency. Never rejects: a
  // failed check must not block the caller, which would only be worse off.
  function ensure() {
    if (pending) return pending;
    pending = fetch(root + 'cart.js', { credentials: 'same-origin' })
      .then(function (res) {
        return res.json();
      })
      .then(function (cart) {
        if (cart.currency === pageCurrency) return true;
        return relocalise().then(function (next) {
          return next.currency === pageCurrency;
        });
      })
      .catch(function (e) {
        console.log(e);
        return true;
      })
      .then(function (ok) {
        pending = null;
        return ok;
      });
    return pending;
  }

  window.marketGuard = { ensure: ensure };

  // A normal load already localises the cart; only a restored page needs it.
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) ensure();
  });

  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible') ensure();
  });
})();
